import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Data } from '../../comum/data/data';
import { FiltroReincidencia } from '../../comum/modelos/filtro-reincidencia';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioService } from '../../usuario/usuario.service';
import { SelectItem, ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-pesquisa-reincidencia',
    templateUrl: './pesquisa-reincidencia.component.html',
    styleUrls: ['./pesquisa-reincidencia.component.css']
})
export class PesquisaReincidenciaComponent implements OnInit {

    usuarios: Usuario[];
    usuariosSelectItem: SelectItem[];
    usuariosSelecionados: number[] = [];
    filtroReincidencia: FiltroReincidencia;
    dateFormat = 'dd/mm/yy';
    selecione = 'Selecione';
    pt: any;
    statusCode: number;
    public loading = false;

    constructor (
        private _usuarioService: UsuarioService,
        private _cookieService: CookieService,
        private authService: AuthService,
        private confirmationService: ConfirmationService,
        private router: Router,
        private data: Data) {
        this.usuarios = new Array<Usuario>();
        this.usuariosSelectItem = new Array<SelectItem>();
        this.filtroReincidencia = new FiltroReincidencia();
    }

    ngOnInit() {
        this.pt = {
            firstDayOfWeek: 1,
            dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
            dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
                'outubro', 'novembro', 'dezembro'],
            monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
            today: 'Hoje',
            clear: 'Apagar'
        };
        this.loading = true;
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
        const self = this;

        if (this.authService.isAdmin) {
            this._usuarioService.obterUsuariosHttp(idCliente)
                .subscribe(usuarios => {
                    this.usuarios = usuarios;
                    this.usuarios.forEach(usuario => {
                        this.usuariosSelectItem.push({ label: usuario.nomeUsuario, value: usuario.idUsuario });
                    });
                    self.loading = false;
                });
        } else {
            const usuario = JSON.parse(this._cookieService.get('usuario'));
            this._usuarioService.buscarUsuariosFuncionalidadeHttp(idCliente, 'Reincid\u00eancias - Usu\u00e1rios',
                usuario.idUsuario)
                .subscribe(usuarios => {
                    this.usuarios = usuarios;
                    this.usuarios.forEach(usr => {
                        this.usuariosSelectItem.push({ label: usr.nomeUsuario, value: usr.idUsuario });
                    });
                    self.loading = false;
                });
        }
    }

    onSubmit(): void {
        if (this.filtroReincidencia.dataInicioReferencia === undefined || this.filtroReincidencia.dataFimReferencia === undefined) {
            this.confirmationService.confirm({
                rejectVisible: false,
                message: 'Favor informar ambas as datas para pesquisa',
                accept: () => { },
                reject: () => { }
            });
        } else if (this.filtroReincidencia.dataInicioReferencia > this.filtroReincidencia.dataFimReferencia) {
            this.confirmationService.confirm({
                rejectVisible: false,
                message: 'A data final tem de ser maior que a data inicial',
                accept: () => { },
                reject: () => { }
            });
        } else {
            this.loading = true;
            this.filtroReincidencia.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
            if (this.usuariosSelecionados.length > 0) {
                this.filtroReincidencia.idUsuario = this.usuariosSelecionados;
            } else {
                const ids = new Array<number>();
                ids.push(JSON.parse(this._cookieService.get('usuario')).idUsuario);
                this.filtroReincidencia.idUsuario = ids;
            }
            this.data.storage = {
                'filtroReincidencia': this.filtroReincidencia
            };
            this.router.navigate(['listar-reincidencias']);
            this.loading = false;
        }
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/pesquisa-reincidencia/pesquisa-reincidencia.component.ts